function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 20,
  transform: "matrix(-1 0 0 1 17 0)",
  fill: "url(#pattern0)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_2355_1026",
  transform: "matrix(0.0322581 0 0 0.0274194 0 -0.00725806)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_2355_1026",
  width: 31,
  height: 37,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAlCAYAAAC6TzLyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFxEAABcRAcom8z8AAAI/SURBVFhHvZYvd8JAEMSRSCQSiaysRFYiK/kISCSuH6GysrKyshKJrERWVlZBOpMdbpPmcvlD0t97eSGzu7MQkr2b/CeXy+X+fD6/8ciy7E7yuKDRDA1fcA7g+qTweKDPBo2+rWUZpQwPvO/Q9GBt4ih1OODJW/xk9mlUMgzwW6Pxl1mXgf6jjwGV3QZ8ljB/N8sqii3sylF5P1A/xbGP/SrCu4DX60HpzC8huTs0hfmnfCogxv99qvQciziS24OaOYw5JKIg9oHTUuklLMOR3A7k72AefWeh80HbKDWKZTqS02gsHlVTAbFnnGZKr8WyHclxEK+MxSKIHfjFlN6IygKSqyBWOxapo+lWqa1ReUCyAy05FhF7xWmu9E6YgyM5DyTHImJ8rVZK74U5OVexaSzucJTe2T7khgUo0DgKGudjUbU3Y67OBA1O+lwCD9SjagZD1gE2jy4I0PmkJ4dGV8zZocAHjU9wFMT45A+y3zJHR3IeWKFR00LROMVSmJMj2cA1l0jO79olEqe10jtjLo7kMtAXaNS0OYiuXCms2pEcR2t26v3f42j9/ueFBSTXg5wpGiUnH7+k0pOoJCC5GeRyn8aNQhTEuMFIznzLdCS3BzVc7er+Cs6GnVIrWJYjuRuo42zgBiIKYsfYOq9wQHI/2ACNUssvNyJhNpjqSL4NfImtbnkF6fmYNsXJi4cAXtzVNo3pEiodDngmx3QRlQwLfJNj+orSxwH+yTGttHGJjWneFYXHB/3+jOls9wsfW55ZWM0AowAAAABJRU5ErkJggg=="
}));

function SvgPromoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoIcon);
export default __webpack_public_path__ + "static/media/promo-icon.32af647d.svg";
export { ForwardRef as ReactComponent };